import debounce from 'lodash/debounce';
import $ from 'jquery';
import Utils from '@core/base/scripts/utils/utils.js';

export default class SwapBackground {

  /**
   * Constructor method
   *
   * @param $elt
   */
  constructor($elt) {
    this.TIMEOUT=100;
    this.SPEED = 300;
    this.opacity=1;
    //
    this.$elt = $elt;
    //
    this.currentSize = null;
    this.lastSize = '';
    this.srcSm = null;
    this.srcLg = null;
    this.srcDefault = null;
  }

  /**
   * Init method
   *
   * @param callback
   */
  init() {
    this.srcSm = this.$elt.data('img-sm');
    this.srcLg = this.$elt.data('img-lg');
    this.srcDefault = this.$elt.data('img-default');

    const debouncedResize = debounce(() => {
      this.swapImages();
    }, this.TIMEOUT);

    $(window).on('resize', debouncedResize);
    debouncedResize();
  }


  /**
   * Method used to swap image sizes
   *
   * @param callback
   */
  swapImages(callback) {
    let src;
    if (window.matchMedia(`(min-width: ${Utils.breakpoints.lg}px)`).matches) {
      src = this.srcLg;
      this.currentSize='lg';
    } else if (window.matchMedia(`(min-width: ${Utils.breakpoints.sm}px)`).matches) {
      src = this.srcSm;
      this.currentSize='sm';
    } else {
      src = this.srcDefault;
      this.currentSize='default';
    }

    if (this.lastSize !== this.currentSize) {
      this.preload(src,() => {
        if (callback) {
          callback();
        }
      });
    }
  }


  /**
   * Method used to preload images
   *
   * @param src
   * @param callback
   */
  preload(src, callback) {
    this.$elt.css({
      'opacity': 0,
    });
    const $newImg = $('<img>');
    $newImg.attr('src', src);

    $newImg.off().on('load', () => {
      this.$elt.css({
        'background-image': `url(${src})`,
      });
      this.$elt.animate({
        opacity: this.opacity,
      }, this.SPEED);
      this.lastSize = this.currentSize;
      if (callback) {
        callback();
      }
    });
  }
}
